/**
 * @generated SignedSource<<5398838ec21428279578b942b6fcbb54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeroCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_user">;
  readonly " $fragmentType": "PdpRespUnavailableHeroCarousel_user";
};
export type PdpRespUnavailableHeroCarousel_user$key = {
  readonly " $data"?: PdpRespUnavailableHeroCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeroCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeroCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8316c0d80f2f18408a9446ed9849777c";

export default node;
